<template>
  <b-form-group
    label="2. Ukuran"
    label-for="ukuran"
  >
    <b-row>
      <b-col cols="11">
        <b-form-input
          v-model="ukuran"
          disabled
        />
      </b-col>
      <b-col cols="1">
        <label for="satuan">{{ satuan }}</label>
      </b-col>
      <b-col
        cols="11"
        offset-md="1"
        class="mt-1"
      >
        <b-form-radio
          v-model="kesesuaianUkuran"
          value="1"
          disabled
        >
          Sesuai Dengan Data Lama
        </b-form-radio>
        <b-form-radio
          v-model="kesesuaianUkuran"
          value="0"
          disabled
        >
          Tidak Sesuai Dengan Data Lama
        </b-form-radio>

        <b-col
          v-if="kesesuaianUkuran === '0'"
          cols="11"
          offset-md="1"
          class="mt-1"
        >
          <label
            for="ukuranSeharusnya"
            class="d-block"
          >
            Ukuran Seharusnya
            <small class="text-warning">
              Wajib mengacu pada dokumen yang dapat dipertanggungjawabkan
            </small>
          </label>
          <b-row>
            <b-col cols="11">
              <slot />
            </b-col>
            <b-col cols="1">
              <label for="satuan">{{ satuanSeharusnya }}</label>
            </b-col>
          </b-row>
        </b-col>
      </b-col>
    </b-row>
  </b-form-group>
</template>
<script>
export default {
  props: {
    ukuran: { type: String, default: '' },
    satuan: { type: String, default: '' },
    kesesuaianUkuran: { type: String, default: '' },
    satuanSeharusnya: { type: String, default: '' },
  },
}
</script>
